import { Skeleton } from "@arcadeai/design-system/components/ui/atoms/skeleton";

export const BillingOverviewSkeleton = () => (
  <div className="mx-auto space-y-8">
    <Skeleton className="h-10 w-full max-w-sm" />
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
      <Skeleton className="col-span-1 h-72 lg:col-span-2" />
      <Skeleton className="col-span-1 h-72" />
    </div>
    <Skeleton className="h-48 w-full" />
  </div>
);
